import React from "react";
import { convertThenFormat, formatDateTime } from "../common-data/Converts";
import { formatWTFString } from "../common-data/Conversions";
import { getStatusLabel } from "./ExpenseRequestLists";
import "../../styles/expense/ExpenseRequestListsMobileV2.css";

const ExpenseRequestListsMobileV2 = ({
  tableData,
  setModValues,
  tablePagination,
  isPage,
  setIsPage,
  isLeadLoading,
  userInfoData,
  pageLimit,
  setPageLimit,
  isExpenseManager,
  expenseManagerRole,
  handleVendorImageUpload,
}) => {
  const handlePrintImage = (requestedImg) => {
    if (requestedImg) {
      const printWindow = window.open("", "_blank");
      const printContent = `
        <html>
          <head>
            <title>Print Bill</title>
            <style>
              body {
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0;
                padding: 20px;
              }
              img {
                max-width: 100%;
                height: auto;
              }
            </style>
          </head>
          <body>
            <img src="${requestedImg}" alt="Bill Image" />
          </body>
        </html>
      `;
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.onload = () => {
        printWindow.print();
        printWindow.onafterprint = () => {
          printWindow.close();
        };
      };
    }
  };

  const getStatusIcon = (status) => {
    const planStatus = status?.replace(/ /g, "_")?.toLowerCase();

    switch (planStatus) {
      case "approved_paid":
        return (
          <div className="status-icon approved">
            <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>
          </div>
        );
      case "approved_notpaid":
        return (
          <div className="status-icon approved-pending">
            <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z" />
              <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z" />
              <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5" />
            </svg>
          </div>
        );
      case "pending":
        return (
          <div className="status-icon pending">
            <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
            </svg>
          </div>
        );
      default:
        return (
          <div className="status-icon rejected">
            <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
            </svg>
          </div>
        );
    }
  };

  const renderVendorPaymentStatus = (row) => {
    const planStatus = row?.status?.replace(/ /g, "_")?.toLowerCase();
    const isReceptionist =
      userInfoData?.account_type === "receptionist" ||
      userInfoData?.account_type === "trainer";
    const isPaidStatus = planStatus === "approved_paid";

    if (row?.vendor_paid_img) {
      return (
        <div className="vendor-status verified">
          <div className="status-header">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>
            <span>Payment Verified</span>
          </div>
          <img
            src={row.vendor_paid_img}
            alt="Payment Proof"
            className="payment-proof-img"
            onClick={() => {
              const printWindow = window.open("", "_blank");
              const printContent = `
                <html>
                  <head>
                    <title>Payment Proof</title>
                    <style>
                      body { margin: 0; padding: 20px; display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f8f9fa; }
                      img { max-width: 100%; height: auto; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); }
                    </style>
                  </head>
                  <body>
                    <img src="${row.vendor_paid_img}" alt="Payment Proof" />
                  </body>
                </html>
              `;
              printWindow.document.write(printContent);
              printWindow.document.close();
            }}
          />
          <small>Tap to view</small>
        </div>
      );
    } else if (isPaidStatus && isReceptionist) {
      return (
        <div className="vendor-status upload-required">
          <div className="status-header">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
            </svg>
            <span>Proof Required</span>
          </div>
          <button
            className="upload-btn"
            onClick={() =>
              handleVendorImageUpload && handleVendorImageUpload(row?.uid, row)
            }
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path
                fillRule="evenodd"
                d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383"
              />
              <path
                fillRule="evenodd"
                d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708z"
              />
            </svg>
            Add Receipt
          </button>
          <small>Payment made - attach receipt</small>
        </div>
      );
    } else if (isPaidStatus && !isReceptionist) {
      return (
        <div className="vendor-status awaiting">
          <div className="status-header">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
            </svg>
            <span>Awaiting Receipt</span>
          </div>
          <div className="status-message">
            <p>Payment completed</p>
            <strong>Receipt will be added by desk</strong>
          </div>
        </div>
      );
    } else {
      return (
        <div className="vendor-status processing">
          <div className="status-header">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
            </svg>
            <span>Processing</span>
          </div>
          <div className="status-message">
            {planStatus === "pending"
              ? "Under review"
              : planStatus === "approved_notpaid"
              ? "Approved - processing payment"
              : "Requires approval"}
          </div>
        </div>
      );
    }
  };

  const renderPagination = () => {
    if (!tablePagination || tablePagination.length === 0) return null;

    return (
      <div className="mobile-pagination">
        <div className="pagination-info">
          <span>
            Page {isPage} of {tablePagination.length}
          </span>
        </div>
        <div className="pagination-controls">
          <button
            className="pagination-btn"
            disabled={isPage <= 1}
            onClick={() => setIsPage(isPage - 1)}
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path
                fillRule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              />
            </svg>
          </button>
          <button
            className="pagination-btn"
            disabled={isPage >= tablePagination.length}
            onClick={() => setIsPage(isPage + 1)}
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path
                fillRule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="expense-requests-mobile-v2-wrapper">
      {!tableData || tableData.length === 0 ? (
        <div className="empty-state">
          <svg width="64" height="64" fill="currentColor" viewBox="0 0 16 16">
            <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
          </svg>
          <h3>No Expense Requests</h3>
          <p>No expense requests found for the current filters.</p>
        </div>
      ) : (
        <>
          {tableData.map((row, index) => {
            const planStatus = row?.status?.replace(/ /g, "_")?.toLowerCase();
            const isSameAccount =
              (userInfoData?.uid || userInfoData?.user_id) ===
              row?.requested_by;
            const isEditDisable = !isSameAccount || planStatus !== "pending";
            const isReceptionist =
              userInfoData?.account_type === "receptionist";

            return (
              <div key={index} className="expense-card">
                <div className="card-header">
                  <div className="status-section">
                    {getStatusIcon(row?.status)}
                    <div>
                      <div className="status-text">
                        {getStatusLabel(row?.status || "-")}
                      </div>
                      <div className="expense-type">
                        {formatWTFString(row?.expense_type || "")}
                      </div>
                    </div>
                  </div>
                  <div className="amount-section">
                    <div className="amount">
                      ₹{convertThenFormat(row?.requested_amount || 0)}
                    </div>
                    {row?.gym_name && (
                      <small style={{ color: "#6c757d", fontSize: "12px" }}>
                        {row.gym_name}
                      </small>
                    )}
                  </div>
                </div>

                <div className="card-details">
                  <div className="detail-row">
                    <div className="detail-label">Requested By</div>
                    <div className="detail-value">
                      <div className="requested-by">
                        <strong>{row?.requested_by_name || "NA"}</strong>
                        <small>
                          {row?.requested_by_email && (
                            <div>{row.requested_by_email}</div>
                          )}
                          {row?.requested_by_mobile && (
                            <div>{row.requested_by_mobile}</div>
                          )}
                        </small>
                      </div>
                    </div>
                  </div>

                  <div className="detail-row">
                    <div className="detail-label">Payment Method</div>
                    <div className="detail-value">
                      <div className="payment-method-info">
                        <strong>{row?.payment_method || "NA"}</strong>
                        {row?.payment_method === "bank" && (
                          <small>
                            <div>Account: {row?.account_number || ""}</div>
                            <div>IFSC: {row?.ifsc_code || ""}</div>
                          </small>
                        )}
                        {row?.payment_method === "upi" && (
                          <small>
                            <div>{row?.upi_id || ""}</div>
                          </small>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="detail-row">
                    <div className="detail-label">Date Added</div>
                    <div className="detail-value">
                      {row?.date_added ? formatDateTime(row.date_added) : "-"}
                    </div>
                  </div>
                </div>

                {renderVendorPaymentStatus(row)}

                <div className="card-actions">
                  <button
                    className="action-btn primary"
                    onClick={() => {
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        cardName: "view_details",
                        rowData: row,
                      }));
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                    </svg>
                    View Details
                  </button>

                  <button
                    className="action-btn secondary"
                    onClick={() => handlePrintImage(row?.requested_img)}
                    disabled={!row?.requested_img}
                  >
                    <svg
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708" />
                    </svg>
                    Print Bill
                  </button>

                  {isReceptionist && isSameAccount && (
                    <button
                      className="action-btn danger"
                      disabled={isEditDisable}
                      onClick={() =>
                        setModValues((prevs) => ({
                          ...prevs,
                          isModOpen: true,
                          cardName: "edit",
                          rowData: row,
                        }))
                      }
                    >
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                      </svg>
                      Edit
                    </button>
                  )}
                </div>
              </div>
            );
          })}

          {renderPagination()}
        </>
      )}
    </div>
  );
};

export default ExpenseRequestListsMobileV2;
